document.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('block-editor-page')) return

  const elementsToAnimate = document.querySelectorAll('.credo-timeline__item')

  // 1. Kezdő állapot beállítása: Legyenek láthatatlanok, mielőtt az observer elindul.
  elementsToAnimate.forEach((el) => {
    el.classList.add('will-animate')
    const children = el.querySelectorAll('.credo-timeline__year-badge, .credo-timeline__title, .credo-timeline__description')
    children.forEach((child) => child.classList.add('will-animate'))
  })

  /*
  // ── Vonal animáció ──────────────────────────────
  const timeline = document.querySelector('.credo-timeline')
  const lineFill = document.querySelector('.credo-timeline__line-fill')

  if (timeline && lineFill) {
    const updateLine = () => {
      const rect = timeline.getBoundingClientRect()
      const windowH = window.innerHeight
      const progress = Math.min(1, Math.max(0, (windowH - rect.top) / (windowH + rect.height)))
      lineFill.style.transform = `scaleY(${progress})`
    }
    window.addEventListener('scroll', updateLine, { passive: true })
    updateLine()
  }
  */

  // ── Elem animációk ──────────────────────────────
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        const item = entry.target

        // 2. Animáció indítása
        // A 'will-animate' már rajta van, csak az 'animate-in' kell.
        requestAnimationFrame(() => {
          item.classList.add('animate-in')
        })

        const badge = item.querySelector('.credo-timeline__year-badge')
        if (badge) {
          setTimeout(() => badge.classList.add('animate-in'), 500)
        }

        const title = item.querySelector('.credo-timeline__title')
        if (title) {
          setTimeout(() => title.classList.add('animate-in'), 700)
        }

        const desc = item.querySelector('.credo-timeline__description')
        if (desc) {
          setTimeout(() => desc.classList.add('animate-in'), 900)
        }

        observer.unobserve(item)
      })
    },
    { threshold: 0.2 },
  )

  elementsToAnimate.forEach((el) => observer.observe(el))
})
